module.exports = __webpack_public_path__ + "img/1.7ec729a0.jpg";